import { SkeletonLoader, WithLoadingComponent } from 'components/shared';
import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router';
import { FolderService } from 'services/http';
import { SiderItem, SiderParentLabel } from "./";
import { BASE_ROUTES } from 'utils';

const FolderSide = (props) => {

    const history = useHistory();
    const { data: folders } = props;

    useEffect(() => {
        initRouteNav(folders);
    }, []);

    const initRouteNav = (items) => {
        let currentFolder = new URLSearchParams(window.location.search).get('folder-id');
        !currentFolder && history.push(`${BASE_ROUTES.FOLDERS_ROUTE}/${items[1].description}?folder-id=${items[1].folderId}&folder-item=${items[1].description}`);
    }

    return (
        <>
            <SiderParentLabel icon="bi bi-folder-fill" label="FOLDERS" />
            <div className="overflow-auto" style={{ height: "80vh" }} >
                {
                    folders.map(item =>
                        <SiderItem
                            key={item.folderId}
                            route={`${BASE_ROUTES.FOLDERS_ROUTE}/${item.description}?folder-id=${item.folderId}&folder-item=${item.description}`}
                            icon={item.icon}
                            label={`${item.description}`}
                        />
                    )
                }
            </div>
        </>
    )
};

//export const FolderSideHoc = WithLoadingComponent(FolderSide, () => FolderService.getFolderItems(), <SkeletonLoader factor={7} />)();

export const FolderSideHoc = () => {
    let Hoc = useMemo(() => WithLoadingComponent(FolderSide, () => FolderService.getFolderItems(), <SkeletonLoader rectangle factor={15} />)(), []);
    return <Hoc />
}
